import { Page } from '@/components/layout/Page';
import { PageContent } from '@/components/layout/PageContent';
import { Skeleton } from '@/components/ui/Skeleton';

function RaceCardSkeleton() {
    return (
        <div className="bg-white p-5 rounded-3xl border border-slate-100 shadow-sm flex flex-col h-full">
            <div className="flex justify-between items-start mb-4">
                <Skeleton className="w-12 h-12 rounded-2xl" />
                <Skeleton className="w-16 h-5 rounded-full" />
            </div>
            <Skeleton className="h-5 w-3/4 mb-4" />
            <div className="space-y-2 mt-auto pt-4">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-24" />
            </div>
        </div>
    );
}

export function HomeSkeleton() {
    return (
        <Page className="bg-slate-50">
            <PageContent width="wide" className="space-y-8 pb-24">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div className="space-y-2">
                        <Skeleton className="h-7 w-48" />
                        <Skeleton className="h-4 w-64" />
                    </div>
                    <Skeleton className="h-12 w-44 rounded-2xl" />
                </div>

                {/* Stats */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm space-y-2">
                        <Skeleton className="h-3 w-20" />
                        <Skeleton className="h-7 w-10" />
                    </div>
                    <div className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm space-y-2">
                        <Skeleton className="h-3 w-16" />
                        <Skeleton className="h-7 w-10" />
                    </div>
                </div>

                {/* Section title */}
                <Skeleton className="h-5 w-40" />

                {/* Race cards grid */}
                <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <RaceCardSkeleton key={i} />
                    ))}
                </div>
            </PageContent>
        </Page>
    );
}
